import { Injectable } from '@angular/core';
import { createServer, Server } from 'miragejs';
import { Registry as MirageRegistry } from 'miragejs/-types';
import { CookieService } from 'ngx-cookie-service';
import { ADMIN, IDENTITY_PROVIDER } from './data/authorization';
import { AUTHORIZATION_MODEL, IDENTITY_PROVIDER_MODEL } from './data/util';
import { initializeStaticAssets } from './functions/static';
import { IdentityProviderIdManager } from './identity_managers/identity-provider-id-manager';
import { RoutesData } from './model/routes.model';
import { MOCK_FACTORIES, MOCK_MODELS } from './model/typings.model';
import { initializeRoutes } from './routes/routes';

@Injectable({
  providedIn: 'root'
})
export class MirageService {
  constructor(private cookieService: CookieService) {}

  startServer(): Server<MirageRegistry<typeof MOCK_MODELS, typeof MOCK_FACTORIES>> {
    const cookieService = this.cookieService;
    return createServer<typeof MOCK_MODELS, typeof MOCK_FACTORIES>({
      models: MOCK_MODELS,
      factories: MOCK_FACTORIES,
      identityManagers: {
        identityProvider: IdentityProviderIdManager
      },
      seeds(server): void {
        server.create(AUTHORIZATION_MODEL, ADMIN);
        server.create(IDENTITY_PROVIDER_MODEL, IDENTITY_PROVIDER);
      },
      routes(): void {
        const routesData: RoutesData = {
          authorizationData: {
            providerName: cookieService.get('wa-mock-auth')
          }
        };
        initializeRoutes(this, routesData);
        initializeStaticAssets(this.pretender);
      }
    });
  }
}
